module.exports = __webpack_public_path__ + "img/about-5.6cd5fbd9.jpg";